


import FlatSelectorIconSwitch, {
  SwitchIconsOption,
  IconSwitchColorSeparator,
} from '@/shared/components/FlatSelectorIconSwitch.component.vue';
import { Component, Vue } from 'vue-property-decorator';
import Assets from '@/constants/assets';

@Component({
    components: {
        FlatSelectorIconSwitch,
    },
})

export default class PartialFlatSelectorIconSwitch extends Vue {
  private icons: SwitchIconsOption[] = [
    {
      id: 1,
      src: Assets.iconInvestment,
    },
    {
      id: 2,
      src: Assets.iconExpense,
    }];
  private icons2: SwitchIconsOption[] = [
    {
      id: 1,
      src: Assets.iconInvestment,
    }];
  private iconSelected: SwitchIconsOption = this.icons[0];
  private iconSwitchColorSeparator = IconSwitchColorSeparator;
  private colorSeparator = this.iconSwitchColorSeparator.Primary;

  private selectedOption(iconSelected: SwitchIconsOption) {
    this.iconSelected = iconSelected;
    this.colorSeparator = this.iconSwitchColorSeparator.Secondary;

    this.setColor();
  }

  private setColor() {
    if (this.iconSelected === this.icons[0]) {
      this.colorSeparator = this.iconSwitchColorSeparator.Primary;
    }
  }
}
